export function initHeroVideoToggle(): void {
  const pauseButton = document.querySelector<HTMLElement>('.js-heroimage-video-pause');
  if (!pauseButton) {
    return;
  }

  const videos = [
    document.querySelector<HTMLVideoElement>('.js-heroimage-video-desktop'),
    document.querySelector<HTMLVideoElement>('.js-heroimage-video-mobile'),
  ].filter((v): v is HTMLVideoElement => v !== null);

  if (videos.length === 0) {
    return;
  }

  const labels = {
    pause: pauseButton.dataset.arialabelplaying || 'Pause video',
    play: pauseButton.dataset.arialabelpausing || 'Play video',
  };

  const setState = (playing: boolean): void => {
    pauseButton.dataset.state = playing ? 'playing' : 'paused';
    pauseButton.setAttribute('aria-pressed', playing ? 'false' : 'true');
    pauseButton.setAttribute('aria-label', playing ? labels.pause : labels.play);
  };

  pauseButton.addEventListener('click', () => {
    const isPlaying = videos.some((v) => !v.paused);
    videos.forEach((v) => {
      if (isPlaying) {
        v.pause();
      } else {
        v.play();
      }
    });
    setState(!isPlaying);
  });
}

